<div id="rvrsCreateStep3">
  <app-confirm-dialog></app-confirm-dialog>
  <app-rvrs-search-point-modal (onCloseToParent)="addSearchPoint($event)"></app-rvrs-search-point-modal>
  <h1>Step 3: Audit Details and Search Points</h1>
  <div id="details">
    <h4>Details</h4>
    <div>
      <div class="inputPadding">
        <label for="accountId">
          Account ID
          <label class="asterix">*</label>
        </label>
        <input id="accountId" type="text" [(ngModel)]="dataToSave.CustomerAccountID" />
        <span class="leftSpacing"></span>
        <label for="accountName">
          Account Name
          <label class="asterix">*</label>
        </label>
        <input id="accountName" type="text" [(ngModel)]="dataToSave.CustomerAccountName" />
        <span class="leftSpacing"></span>
        <label for="searchRadius">
          Search Radius (mi.)
        </label>
        <kendo-numerictextbox id="searchRadius" [(ngModel)]="searchRadiusMiles"
          [min]="1" [max]="20" [autoCorrect]="true" [format]="'n0'"
            (keydown)="blockDelete($event)"  ></kendo-numerictextbox>
        <span class="max20">Max 20</span>

        <span class="leftSpacing"></span>
        <label for="dateOfStay">
          Date of stay
          <label class="asterix">*</label>
        </label>
        <kendo-datepicker id="dateOfStay" name="dstay" #dstay  (valueChange)="onDateOfStayChange($event)" [value]="initialDateOfStay" [min]="minAuditDate"
          [max]="maxAuditDate" ></kendo-datepicker>
          <span class="leftSpacing"></span>
          <label for="sabrePCC">
          Sabre PCC
        </label>
        <input id="sabrePCC"
        type="text"
        [disabled]="!dataToSave.AuditSabre"
        [(ngModel)]="dataToSave.SabrePCC"
         />

      </div>



      <div class="inputPadding">
        <div class="groupLabel">GDS Selection </div>
        <div>
          <ngl-checkbox label="Amadeus">
            <input ngl type="checkbox" name="Amadeus" [disabled]="disableAuditAmadeus" [(ngModel)]="dataToSave.AuditAmadeus"/>
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Apollo">
            <input ngl type="checkbox" name="Apollo" [disabled]="disableAuditApollo" [(ngModel)]="dataToSave.AuditApollo"/>
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Galileo">
            <input ngl type="checkbox" name="Galileo" [disabled]="disableAuditGalileo" [(ngModel)]="dataToSave.AuditGalileo"/>
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Sabre">
            <input ngl type="checkbox" name="Sabre" [disabled]="disableAuditSabre" [(ngModel)]="dataToSave.AuditSabre"/>
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Worldspan">
            <input ngl type="checkbox" name="Worldspan" [disabled]="disableAuditWorldspan" [(ngModel)]="dataToSave.AuditWorldspan"/>
          </ngl-checkbox>
        </div>
      </div>
      <div id="row2">

        <div id="rate-finder-keywords">
          <div>

            <h5>Rate Access Code Filters *</h5>
            <div>
              <div class="keywordCtrls">
                <div>
                    <label title="">Keyword To Add
                        <input type="text" class="upperCaseOnly" [(ngModel)]="keywordToAdd"  />
                      </label>
                      <button class="k-button cvt-primary" (click)="addKeyordClick()" [disabled]="invalidKeyword" >Add Keyword</button>
                </div>
                <label>Original Imported Keyword List</label>
                <p class="originalKeyword">{{originalKeywordList}}</p>
              </div>
              <div class="keywordList">
                <app-configurable-link-list (deleteClickedOutput)="deleteKeyword($event)" [list]="keywordList">
                </app-configurable-link-list>
              </div>
            </div>
          </div>
        </div>
        <div id="auditProcessing">
          <div>

            <h5>Processing Details</h5>
            <form>
              <fieldset ngl-radio-group label="Schedule Audit" class="notslds-m-top--small">
                <ngl-radio-option label="Run Audit Now">
                  <input ngl type="radio" name="runNow" [checked]="runAuditNow" (click)="onRunNowClick(true)" />
                </ngl-radio-option>
                <ngl-radio-option id="schedeuled-radio" label="Schedule Job to Run At:">
                  <input ngl type="radio" name="scheduled" [checked]="!runAuditNow" (click)="onRunNowClick(false)" /> </ngl-radio-option>
                <kendo-datepicker name="dpick" #dpick [disabled]="runAuditNow" [value]="scheduledTime" (valueChange)="updateScheduledTime($event)"
                  [min]="earliestRunDate" [max]="lastRunDate"></kendo-datepicker>
                <kendo-timepicker name="tpick" #tpick [disabled]="runAuditNow" [format]="'T'" [value]="scheduledTime" (valueChange)="updateScheduledTime($event)"></kendo-timepicker>
              </fieldset>
            </form>

            <div class="inputPadding">
              <div id="notifications">
                <ngl-checkbox label="Enable Notifications">
                  <input ngl type="checkbox" name="EnableNotifications" (click)="onEnableNotifications($event)" />
                </ngl-checkbox>
                <div>
                  <label for="notifTemplate"> Notification Template</label>
                  <kendo-dropdownlist id="notifTemplate" #notifTemplate [data]="_notificationTemplateList" [disabled]="!dataToSave.SendNotifications"
                    valueField="id" textField="name" [(ngModel)]="notificationSelection" [valuePrimitive]="true" [allowCustom]="false"
                    [popupSettings]="dropdownPopupSettings" item-width="300">
                    <ng-template *ngIf="!dataToSave.SendNotifications" kendoDropDownListValueTemplate>
                      <span class="setColor">No Assigned Notification Template</span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span>{{dataItem.name}}</span>
                    </ng-template>
                  </kendo-dropdownlist>
                </div>
                <div>
                  <label title="">Report Failed Emails To
                    <input id="txtFailedEmailContactEmailAddress" type="text" maxlength=255 [(ngModel)]="dataToSave.AuditContactEmailAddress"
                       />
                  </label>

                </div>

              </div>
            </div>
          </div>

        </div>
      </div>



    </div>


  </div>
  <div id="searchPoints">
    <h4>Search Points</h4>

    <div class="inputPadding">
      <button (click)="showSearchPointModal($event)" class="k-button cvt-primary">+ Add</button>
      <br/>
      <br/>

      <div id="auditGrid" (paste)="AddSearchPoints($event)">

        <kendo-grid id="kendoGrid"
          [data]="viewResult"
          [pageSize]="state.take"
          [pageable]="{buttonCount: 5,info:norecords}"
          [skip]="state.skip"
          [sort]="state.sort"
          [sortable]="true"
          [pageable]="true"
          [scrollable]="'scrollable'"
          (dataStateChange)="dataStateChange($event)"
          (pageChange)="pageChange($event)"
          >


          <kendo-grid-column field="what" title="Action" [width]="25">
              <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem >
                  <div class="raui-grid-buttons">
                        <a class="cvt-icon-trash  grid-cmd-icons" (click)="removeRow(rowIndex)" title="Delete Search Point from list"></a>
                  </div>
                </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="Name" title="Name" [width]="90">
          </kendo-grid-column>
          <kendo-grid-column field="Radius" title="Radius" [width]="35">
          </kendo-grid-column>

          <kendo-grid-column field="Latitude" title="Latitude" [width]="50">

          </kendo-grid-column>
          <kendo-grid-column field="Longitude" title="Longitude" [width]="50">
          </kendo-grid-column>
          <kendo-grid-column field="PropertyAddress" title="Address" [width]="250">
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

  </div>
</div>
